import { gql } from '@apollo/client'
import client from './../apollo-settings'

const actions = {
    getSchools: async () => {
        try {
            const {data} = await client.query({
                query: gql`
                    query adminSchoolResolver($params: ReactAdminListParams!) {
                        adminSchoolList(params: $params) {
                            data {
                                id
                                title
                            }
                            total
                        }
                    }
                `,
                variables: {params: {pagination: {page: 1, perPage: 99999}, sort: {field: "id", order: "DESC"}, filter: []}}
            })
            return data ? data.adminSchoolList.data : []
        } catch (e) {
            console.log(e)
            return []
        }
    },
    getSchool: async (id) => {
        try {
            const {data} = await client.query({
                query: gql`
                    query adminSchoolGetOne($id: String!) {
                        adminSchoolGetOne(id: $id) {
                            id
                            title
                        }
                    }
                `,
                variables: {id: id.toString()}
            })
            return data ? data.adminSchoolGetOne : null
        } catch (e) {
            console.log(e)
        }
    },
    createSchool: async (school) => {
        try {
            const {data, errors} = await client.query({
                query: gql`
                    mutation adminSchoolCreate($data: SchoolAdminInput!) {
                        adminSchoolCreate(data: $data) {
                            id
                            title
                        }
                    }
                `,
                variables: {data: school}
            })
            return {data, error: errors ? errors[0].message : null}
        } catch (e) {
            console.log(e)
        }
    },
    updateSchool: async (id, data) => {
        try {
            await client.query({
                query: gql`
                    mutation adminSchoolUpdate($id: Int!, $data: SchoolAdminInput!) {
                        adminSchoolUpdate(id: $id, data: $data) {
                            id
                            title
                        }
                    }
                `,
                variables: {id, data}
            })
        } catch (e) {
            console.log(e)
        }
    },
    deleteSchool: async (id) => {
        try {
            await client.query({
                query: gql`
                    mutation adminSchoolDelete($id: Int!) {
                        adminSchoolDelete(id: $id) {
                            id
                        }
                    }
                `,
                variables: {id}
            })
        } catch (e) {
            console.log(e)
        }
    }
}

export default actions